module.exports = __webpack_public_path__ + "static/lord-howe-3dcd3a9f2ba230d8bcb8fc22d5853e8b.jpg";